"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestsFactory = void 0;
const apis_1 = require("./apis");
const buildRequest_1 = require("./buildRequest");
const requestsFactory = (request) => {
    return {
        sports: (0, buildRequest_1.buildRequest)('sports', () => (0, apis_1.sportApi)().getSports(request)),
        categories: (0, buildRequest_1.buildRequest)('categories', () => (0, apis_1.outcomeCategoriesApi)().getOutcomeCategories(request)),
        markets: (0, buildRequest_1.buildRequest)('markets', () => (0, apis_1.marketsApi)().getMarkets(request)),
        currencies: (0, buildRequest_1.buildRequest)('currencies', () => (0, apis_1.currenciesApi)().getCurrencies(request)),
        marketCategories: (0, buildRequest_1.buildRequest)('marketCategories', () => (0, apis_1.marketCategoriesApi)().getMarketCategories(request)),
        marketGroups: (0, buildRequest_1.buildRequest)('marketGroups', () => (0, apis_1.marketGroupsApi)().getMarketGroups(request)),
        systemCurrencies: (0, buildRequest_1.buildRequest)('systemCurrencies', () => (0, apis_1.systemCurrenciesApi)().getSystemCurrencies(request)),
        matchPhases: (0, buildRequest_1.buildRequest)('matchPhases', () => (0, apis_1.matchPhasesApi)().getMatchPhases(request)),
        hotProbabilitiesGroups: (0, buildRequest_1.buildRequest)('hotProbabilitiesGroups', () => (0, apis_1.eventProbabilitiesApi)().getHotProbabilityGroups()),
        entityTags: (0, buildRequest_1.buildRequest)('entityTags', () => (0, apis_1.entityTagsApi)().getEntityTags()),
        virtualCategories: (0, buildRequest_1.buildRequest)('virtualCategories', () => (0, apis_1.virtualCategoriesApi)().getVirtualCategories(request)),
    };
};
exports.requestsFactory = requestsFactory;
//# sourceMappingURL=requestsFactory.js.map